import { MDBTooltip } from "mdb-react-ui-kit";
import ModalOpenBetsChart from "../modals/ModalOpenBetsChart";
import { useSelectFunctions } from "../../functions";

const ButtonOpenBetsBetType = ({
  ticketType,
  raceID,
  userInfo,
  openBetsChartInfo,
  setOpenBetsChartInfo,
}) => {
  const { getOpenBetsByWT } = useSelectFunctions();
  //Function to load Open Bets info by Entry for each betType (Modal)
  const getOpenBetsChartByWT = async () => {
    const res = await getOpenBetsByWT(
      {
        RaceID: raceID,
        WagerType: ticketType,
      },
      userInfo.LogonSessionID
    );

    if (!res.error) {
      setOpenBetsChartInfo(res.RaceTicketMainList);
    }
  };

  return (
    <div>
      <MDBTooltip
        tag="i"
        wrapperProps={{ href: "#" }}
        title="Open Bets"
        placement="top"
        onClick={() => getOpenBetsChartByWT()}
      >
        <i
          onClick={() => getOpenBetsChartByWT()}
          data-toggle="modal"
          data-target="#openBetsChartModal"
          className="material-icons"
        >
          list
        </i>
      </MDBTooltip>
      <ModalOpenBetsChart
        openBetsChartInfo={openBetsChartInfo}
        setOpenBetsChartInfo={setOpenBetsChartInfo}
        userInfo={userInfo}
        wagerTypeId={ticketType}
      />
    </div>
  );
};

export default ButtonOpenBetsBetType;
